<div class="background">
    <!-- Registration Form -->
    <div *ngIf="showRegistration" class="d-flex justify-content-center align-items-center" style="min-height: calc(100vh - 70px); margin-top: 70px;">
        <div class="card p-4" style="max-width: 700px; width: 100%;">
            <div class="row">
                <h3 class="col">Registracija</h3>
            </div>
            <form [formGroup]="registrationFormGroup">
                <div class="row g-3">
                    <!-- Left Column (Stacks on small screens) -->
                    <div class="col-12 col-md-6">
                        <label class="ms-4 mt-3 mb-2" for="usernameInput">Uporabniško ime <span class="text-danger">*</span></label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faUser"></fa-icon>
                            <input id="usernameInput" class="form-control" type="text" formControlName="username" placeholder="Vnesi uporabniško ime">
                        </div>
                        <span *ngIf="username?.dirty && username?.errors?.['required']" class="ms-4 mt-1 text-danger">Uporabniško ime je zahtevano.</span>
    
                        <label class="ms-4 mt-3 mb-2" for="passwordInput">Geslo <span class="text-danger">*</span></label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faLock"></fa-icon>
                            <input
                              id="passwordInput"
                              class="form-control"
                              [type]="show ? 'text' : 'password'"
                              formControlName="password"
                              placeholder="Vnesi geslo"
                            >
                            <button type="button" class="btn btn-link p-0 ms-2" (click)="togglePassword()">
                              <fa-icon [icon]="show ? faEyeSlash : faEye"></fa-icon>
                            </button>
                          </div>
                        <span *ngIf="password?.dirty && password?.errors?.['required']" class="ms-4 mt-1 text-danger">Geslo je zahtevano.</span>
    
                        <label class="ms-4 mt-3 mb-2" for="emailInput">Elektronski naslov <span class="text-danger">*</span></label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faEnvelope"></fa-icon>
                            <input id="emailInput" class="form-control" type="email" formControlName="email" placeholder="mojnaslov@posta.xx">
                        </div>
                        <span *ngIf="email?.dirty && email?.errors?.['required']" class="ms-4 mt-1 text-danger">Elektronski naslov je zahtevan.</span>
    
                        <label class="ms-4 mt-3 mb-2" for="addressInput">Fizični naslov</label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faAddressBook"></fa-icon>
                            <input id="addressInput" class="form-control" type="text" formControlName="address" placeholder="Ulica in hišna števila, pošta">
                        </div>

                        <label class="ms-4 mt-3 mb-2" for="phoneInput">Telefon</label>
                        <div class="d-flex align-items-center">
                            <fa-icon class="me-3" [icon]="faPhone"></fa-icon>
                            <input id="phoneInput" class="form-control" type="tel" formControlName="phone" placeholder="012345678">
                        </div>
                    </div>
    
                    <!-- Right Column (Stacks on small screens) -->
                    <div class="col-12 col-md-6">
    
                        <!-- Organisation Selection -->
                        <label class="ms-4 mt-3 mb-2">Izberi organizacije za naročanje:</label>
                        <div class="ms-4">
                            <div *ngFor="let organisation of organisations" class="form-check">
                                <input 
                                    class="form-check-input"
                                    type="checkbox"
                                    [value]="organisation.organisationID"
                                    (change)="onOrganisationSelected(organisation.organisationID, $event)"
                                    [checked]="selectedOrganisations.includes(organisation.organisationID)"
                                    id="organisation-{{organisation.organisationID}}">
                                <label class="form-check-label" for="organisation-{{organisation.organisationID}}">
                                    {{ organisation.name }}
                                </label>
                            </div>
                        </div>
    
                        <p class="text-muted mt-3 d-flex justify-content-center">
                            Polja označena z <span class="text-danger ms-1 me-1"> * </span> so obvezna.
                        </p>
    
                        <button id="registerButton" class="my-4 btn btn-primary"type="button" 
                                (click)="OnRegisterSubmitted()" [disabled]="registrationFormGroup.invalid || isRegistering">
                            <span *ngIf="!isRegistering">Registriraj se</span>
                            <span *ngIf="isRegistering">Pošiljanje registracije ...</span>
                        </button>
                    </div>
                </div>
            </form>
            <button (click)="toggleForm()" class="btn btn-link w-100 text-center">Že imate račun? Vpis</button>
        </div>
    </div>
    
    <!-- Login Form -->
    <div *ngIf="!showRegistration" class="d-flex justify-content-center align-items-center vh-100">
        <div class="card p-4" style="max-width: 600px; width: 100%;">
            <div class="row">
                <h3 class="col">Prijava</h3>
            </div>
            <form>
                <label class="ms-4 mt-3 mb-2" for="usernameInput">Uporabniško ime</label>
                <div class="d-flex align-items-center">
                    <fa-icon class="me-3 mb-2" [icon]="faUser"></fa-icon>
                    <input id="usernameInput" class="form-control mb-2" type="text" [(ngModel)]="loginUsername" name="username" placeholder="Uporabniško ime" />
                </div>
                <label class="ms-4 mb-2" for="passwordInput">Geslo</label>
                <div class="d-flex align-items-center">
                    <fa-icon class="me-3 mb-2" [icon]="faLock"></fa-icon>
                    <input id="passwordInput" class="form-control mb-2" type="password" [(ngModel)]="loginPassword" name="password" placeholder="Geslo" (keyup.enter)="OnEnterPressed()" />
                </div>
                <button id="sendLoginButton" type="button" class="btn btn-primary" (click)="OnLoginPressed()" [disabled]="isLoggingIn">
                    {{isLoggingIn ? 'Prijavljam se ...' : 'Prijavi se'}}
                </button>
            </form>
            <button (click)="toggleForm()" class="btn btn-link">Še nimaš računa? Registriraj se</button>
        </div>
    </div>
</div>
